module.exports = __webpack_public_path__ + "img/Patent_6.8c72b45c.jpg";